export default "__VITE_ASSET__zNTD0RV9__"